<template>
<b-container
    class="bg-white py-5 d-flex section"
    fluid
    >
    <b-row class="justify-content-center align-self-center mx-auto">
      <b-col cols="12" lg="8">
	
	<b-container class="text-center" fluid>
	  <b-row>
	    <b-col>
	      <div>
		<p class="font-weight-bold mb-0">TrinApp</p>
		<h1 class="red">Crosslink</h1>
		<p class="font-weight-bold">Drawings & Specs</p>
	      </div>
	      <div class="m-5">
		<b-img :src="require('../assets/trinapp_crosslink.png')" style="width: 130px;" />
	      </div>
	      <div class="mx-auto">
		<b-container class="pb-5 font-weight-bold text-left">
		  <b-row class="mb-3">
		    <b-col>
		      <div class="d-flex">
			<font-awesome-icon
			  :icon="faCheck"
			  class="mr-4 mb-auto yellow"
			  />
			<p>Automatically create clickable page links between all your PDF Drawings and Specs.</p>
		      </div>
		    </b-col>
		  </b-row>
		  <b-row class="mb-3">
		    <b-col>
		      <div class="d-flex">
			<font-awesome-icon
			  :icon="faCheck"
			  class="mr-4 mb-auto yellow"
			  />
			<p>Easily and quickly navigate from a high-level construction Drawing to a referenced detailed Drawing, to the related Spec and back.</p>
		      </div>
		    </b-col>
		  </b-row>
		  <b-row class="mb-3">
		    <b-col>
		      <div class="d-flex">
			<font-awesome-icon
			  :icon="faCheck"
			  class="mr-4 mb-auto yellow"
			  />
			<p>Automated extraction and publishing of:

			  <br>Drawings: <span style="font-weight: normal;">Sheet Number, Sheet Title, Discipline, Revision Date, and Revision Reason.</span>

			  <br>Specs: <span style="font-weight: normal;">Section Name and Section Number.</span> </p>
		      </div>
		    </b-col>
		  </b-row>
		  <b-row class="mb-3">
		    <b-col>
		      <div class="d-flex">
			<font-awesome-icon
			  :icon="faCheck"
			  class="mr-4 mb-auto yellow"
			  />
			<p>You will save hours from manual work you no longer need to do.</p>
		      </div>
		    </b-col>
		  </b-row>
		</b-container>
	      </div>
	    </b-col>
	  </b-row>
	  <b-row>
	    <b-col>
	      <div class="text-center mb-5">
		<slot name="button">
		  <b-button
		    size="lg"
		    class="btn-orange mt-5 mx-3"
		    href="https://trinpod.us/pricing?industry=construction"
			>
		    Get Started
		  </b-button>
		</slot>
	      </div>
	    </b-col>
	  </b-row>
	</b-container>
	
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "Layout09",
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    props: {
	checkColor: String
    },
    methods: {
	img: function (image) {
	    require(image)
	},
        scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>
